import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import { isEmpty } from "lodash";
import { normalize } from "normalizr";
import Err from "@Broker/@Routes/error";
import { cancelPlan, deletePaymentMethod, editPaymentMethod, getAccountUsage, getPaymentDetails, setDefaultMethod, subscribeToPlan } from "../api/account-plan-api";
import { SET_ACCOUNT_LIMITS, SET_ACCOUNT_LIMIT, SET_PAYMENT_DETAILS } from "./account-plan-mutations";
import { accountPlanLimitSchema } from "./account-plan-schema";
import { showToast, TOASTR_ERROR_OPTIONS, TOASTR_OPTIONS } from "@Shared/@Utils/constants";
export const LOAD_PLAN_LIMITS = "LOAD_PLAN_LIMITS";
export const LOAD_PLAN_LIMIT = "LOAD_PLAN_LIMIT";
export const LOAD_PAYMENT_DETAILS = "LOAD_PAYMENT_DETAILS";
export const ADD_SUBSCRIPTIONS = "ADD_SUBSCRIPTIONS";
export const CANCEL_SUBSCRIPTIONS = "CANCEL_SUBSCRIPTIONS";
export const SET_CARD_AS_DEFAULT = "SET_CARD_AS_DEFAULT";
export const EDIT_PAYMENT_METHOD = "EDIT_PAYMENT_METHOD";
export const DELETE_PAYMENT_METHOD = "DELETE_PAYMENT_METHOD";
export const LOAD_ACCOUNT_PLAN_DETAILS = "LOAD_ACCOUNT_PLAN_DETAILS";
export const PAYMENT_UPDATE_NOTIFICATION = "PAYMENT_UPDATE_NOTIFICATION";
const actions = {
  [LOAD_PLAN_LIMITS]: async context => {
    if (!context.rootGetters["AccountStore/ACCOUNT_PLAN_IS_FREE"]) return;
    const {
      usesRemaining
    } = await getAccountUsage();
    const {
      entities,
      result
    } = normalize(usesRemaining, [accountPlanLimitSchema]);
    context.commit(SET_ACCOUNT_LIMITS, {
      byId: entities.accountPlanLimits || {},
      allIds: result
    });
  },
  [LOAD_PLAN_LIMIT]: async (context, page) => {
    var _response$usesRemaini;
    if (!context.rootGetters["AccountStore/ACCOUNT_PLAN_IS_FREE"]) return;
    const response = await getAccountUsage(page);
    if (isEmpty(response == null ? void 0 : response.usesRemaining)) {
      throw new Error(_JSON$stringify({
        message: "NotAuthorizedException",
        usageData: response
      }));
    }
    context.commit(SET_ACCOUNT_LIMIT, {
      accountLimit: (response == null ? void 0 : (_response$usesRemaini = response.usesRemaining) == null ? void 0 : _response$usesRemaini[0]) || {},
      page
    });
  },
  [LOAD_PAYMENT_DETAILS]: async context => {
    try {
      const response = await getPaymentDetails();
      context.commit(SET_PAYMENT_DETAILS, response);
    } catch (e) {
      Err.handle(e);
    }
  },
  [ADD_SUBSCRIPTIONS]: async (context, {
    accountsToPay,
    planDuration
  }) => {
    try {
      await subscribeToPlan(accountsToPay, planDuration);
      return {
        succeeded: true
      };
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [CANCEL_SUBSCRIPTIONS]: async (context, {
    accountsToCancel
  }) => {
    try {
      await cancelPlan(accountsToCancel);
      return {
        succeeded: true
      };
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [SET_CARD_AS_DEFAULT]: async (context, paymentId) => {
    try {
      await setDefaultMethod(paymentId);
    } catch (e) {
      Err.handle(e);
    }
  },
  [EDIT_PAYMENT_METHOD]: async (context, {
    paymentId,
    cardExpMonth,
    cardExpYear,
    address
  }) => {
    try {
      await editPaymentMethod(paymentId, cardExpMonth, cardExpYear, address);
      showToast("success", "paymentMethodUpdated");
      return {
        succeeded: true
      };
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [DELETE_PAYMENT_METHOD]: async (context, paymentId) => {
    try {
      await deletePaymentMethod(paymentId);
      return {
        succeeded: true
      };
    } catch (e) {
      Err.handle(e);
      return {
        succeeded: false
      };
    }
  },
  [LOAD_ACCOUNT_PLAN_DETAILS]: async context => {
    try {
      await _Promise.all([context.dispatch(LOAD_PAYMENT_DETAILS), context.dispatch("AccountStore/LOAD_PERSONAL_DETAILS", null, {
        root: true
      })]);
    } catch (e) {
      Err.handle(e);
    }
  },
  [PAYMENT_UPDATE_NOTIFICATION]: async (context, {
    notification: {
      type,
      message,
      title
    },
    data
  }) => {
    showToast(type, message + `|{"name":"${data.payerInfo.payer.givenName} ${data.payerInfo.payer.familyName}"}`, title, type === "error" ? TOASTR_ERROR_OPTIONS : TOASTR_OPTIONS);
  }
};
export default actions;